
import { AfterViewInit, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { PDFDialogComponent } from "src/app/signup-organization/pdf-dialog/pdf-dialog.component";
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/core/services/v2/user.service';
import { EmployerService } from 'src/app/core/services/v2/employer.service';
import { SharedDataService } from 'src/app/core/services/v2/shared-emp-subscription.service';
import { PatientService } from 'src/app/core/services/v2/patient.service';
import { UtilsService } from 'src/app/core/services/v2/utils.service';
import { PaymentProfile } from 'src/app/core/models/UserPaymentProfile/userPaymentProfile';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CreditCardComponent } from 'src/app/market-place/market-place-home/product-checkout/credit-card/credit-card.component';

@Component({
   selector: 'app-employer-choose-plans',
  templateUrl: './employer-choose-plans.component.html',
  styleUrls: ['./employer-choose-plans.component.scss']
})

export class EmployerChoosePlansComponent implements OnInit,AfterViewInit {
  @Input() activeTab: boolean = false;

  subscriptionTypes:any = [];


  user: any = [];
  subscriptionType: number;
  selectedType: number = 0;
  activationType: string;
  userId: number;
  employerId: number;
  isActive: boolean;
  selectedPlan: any={};
  selectedEmployeeIds: number[]=[];
 customerProfileId: string;
creditCards: PaymentProfile[];
// disableSelectButton: boolean = false;
isPaymentInfoMissing: boolean = false;
errorMessage: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private employerService: EmployerService,
    private loaderService: WindowLoaderService,
    public dialog: MatDialog,
    private sharedDataService: SharedDataService, // Add this
    private patientService: PatientService,
    private utils: UtilsService,
    private snackBar: MatSnackBar,

  ) {}
  ngAfterViewInit(): void {
    this.getUserDetails();

  }

  ngOnInit() {
    this.getUserDetails();
    this.GetPaymentInformation();
    


  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeTab'] && this.activeTab === true) {
      this.getUserDetails();
    }
  }
  setTypeValue(value: number) {
    // Find the selected plan using the subscription type ID
    const selectedPlan = this.subscriptionTypes.find(plan => plan.id === value);
    console.log("slected plan setting",selectedPlan)
    
    if (selectedPlan) {
      this.selectedType = selectedPlan.id;

      // Set activationType based on the plan's active status
      this.activationType = selectedPlan.active ? "Activate" : "Deactivate";
    } else {
      console.error('Selected plan not found.');
    }
  }
  getUserDetails() {
    // this.loaderService.show();
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.user = userDetails;
        // this.customerProfileId = this.user.authorizeNetUserID;

        console.log("user", this.user);
        this.userId = userDetails.id;
        this.employerId = userDetails.employerId
        console.log("This is userId: ", this.userId);
        console.log("This is employerId: ", this.employerId);
        this.getPatientSubscriptionTypes(()=>{this.getEmployerHealthSubscriptionByEmployerId();})


      },
      (error) => { console.error(error); }
    );
  }
  getEmployerHealthSubscriptionByEmployerId() {
    this.loaderService.show();
  
    this.employerService.getEmployerHealthSubscription(this.user.employerId).subscribe(
      (result) => {
        if (result && result.resultStatus && result.resultStatus.isSuccess) {
          if (Array.isArray(result.result)) {
            const subscriptions = result.result;
  
            subscriptions.forEach(sub => {
              const active = sub.active;
              const subscriptionTypeId = sub.subscriptionTypeId;
  
              const selectedPlan = this.subscriptionTypes.find(plan => plan.id === subscriptionTypeId);
  
              if (selectedPlan) {
                this.selectedType = subscriptionTypeId;
                this.activationType = active ? "Activate" : "Deactivate";
                this.selectedPlan = selectedPlan;
  
                this.subscriptionTypes = this.subscriptionTypes.filter(plan => plan.id !== subscriptionTypeId);
  
                console.log("Selected Plan:", selectedPlan);
                console.log("Remaining Plans:", this.subscriptionTypes);
              } else {
                console.warn("No matching plan found for subscriptionTypeId:", subscriptionTypeId);
              }
            });
          } else {
            console.warn("Expected an array for result.result, got:", result.result);
          }
        } else {
          const errorMessage = result.resultStatus && result.resultStatus.errorMessages
            ? result.resultStatus.errorMessages.join(", ")
            : "Failed to fetch subscription details.";
          this.utils.showMessageSnackBar(errorMessage, true);
        }
  
        this.loaderService.hide();
      },
      (error) => {
        console.error("Error fetching subscription details:", error);
        this.loaderService.hide();
        this.utils.showMessageSnackBar("An error occurred while fetching subscription details.", true);
      }
    );
  }
  
  
  
  getEmployerHealthSubscriptionByEmployerId123() {
    this.loaderService.show();
    this.employerService.getEmployerHealthSubscription(this.user.employerId).subscribe(
      (result) => {
        if (result && result.resultStatus && result.resultStatus.isSuccess) {  // Check if API call was successful

          if (result.result) {
            console.log("Subscription Details:", result);

            // Extract the required data safely
            const active = result.result.active;
            this.selectedType = result.result.subscriptionTypeId;
            this.activationType = active ? "Activate" : "Deactivate";

            // Find the selected plan
            const selectedPlan = this.subscriptionTypes.find(plan => plan.id === result.result.subscriptionTypeId);
            console.log("selectedPlan", selectedPlan);

            if (selectedPlan) {
              // Filter out the selected plan
              this.subscriptionTypes = this.subscriptionTypes.filter(plan => plan.id !== result.result.subscriptionTypeId);
              console.log("Updated subscriptionTypes", this.subscriptionTypes);

              this.selectedPlan = selectedPlan;
              console.log("Updated selectedPlan", this.selectedPlan);
            } else {
              console.warn("No matching subscription type found!");
            }
          } else {
            console.warn("Invalid response structure:", result);
          }
        } else {
          console.warn("API response indicates failure:", result.resultStatus);
                   // If isSuccess is false, show the error message
                   const errorMessage = result.resultStatus.errorMessages
                   ? result.resultStatus.errorMessages.join(", ")
                   : "Failed to fetch subscription details.";
                 
                 this.utils.showMessageSnackBar(errorMessage, true);
        }

        this.loaderService.hide();
      },
      (error) => {
        console.error("Error fetching subscription details:", error);
        this.loaderService.hide();
        this.utils.showMessageSnackBar("An error occurred while fetching subscription details", true);
      }
    );
}
getEmployerHealthSubscriptionByEmployerId111() {
  this.loaderService.show();

  this.employerService.getEmployerHealthSubscription(this.user.employerId).subscribe(
    (result) => {
      if (
        result &&
        result.resultStatus &&
        result.resultStatus.isSuccess &&
        result.result
      ) {
        console.log("Subscription Details:", result);

        const active = result.result.active;
        this.selectedType = result.result.subscriptionTypeId;
        this.activationType = active ? "Activate" : "Deactivate";

        // Find the selected plan
        const selectedPlan = this.subscriptionTypes.find(function (plan) {
          return plan.id === result.result.subscriptionTypeId;
        });

        console.log("selectedPlan", selectedPlan);

        if (selectedPlan) {
          // Filter out the selected plan from the list
          this.subscriptionTypes = this.subscriptionTypes.filter(function (plan) {
            return plan.id !== result.result.subscriptionTypeId;
          });

          console.log("Updated subscriptionTypes", this.subscriptionTypes);

          this.selectedPlan = selectedPlan;
          console.log("Updated selectedPlan", this.selectedPlan);
        } else {
          console.warn("No matching subscription type found!");
        }
      } else {
        console.warn("API response indicates failure:", result.resultStatus);

        var errorMessage = "Failed to fetch subscription details.";
        if (
          result &&
          result.resultStatus &&
          result.resultStatus.errorMessages &&
          result.resultStatus.errorMessages.length > 0
        ) {
          errorMessage = result.resultStatus.errorMessages.join(", ");
        }

        this.utils.showMessageSnackBar(errorMessage, true);
      }

      this.loaderService.hide();
    },
    (error) => {
      console.error("Error fetching subscription details:", error);
      this.loaderService.hide();
      this.utils.showMessageSnackBar("An error occurred while fetching subscription details", true);
    }
  );
}

  

  updatePatientHealthSubscription1() {

  
    this.loaderService.show();
    this.user.patientId = 0;  // Assign 0 to patientId
    // const isActive = this.activationType === 'Activate';  // True for "Activate", false for "Deactivate"
    this.activationType = "Activate";

    // Check if selectedType is valid and is 'Active'
    if (this.selectedType && this.activationType) {
      // Call the service to update the subscription
    // Navigate to the next component with the subscriptionType as a route parameter
    this.sharedDataService.setData('employerId', this.user.employerId);
    this.sharedDataService.setData('patientId', this.user.patientId);
    this.sharedDataService.setData('subscqriptionTypeId', this.selectedType);
    this.router.navigate(['/employer/setupCheckout', this.selectedType]).then(() => {
      this.loaderService.hide(); // Hide loader after navigation
      document.getElementById("clsModal").click();

    });

    } else {
      // Handle invalid selectedType or inactive type
      console.log("Please select a valid active subscription type.");
      this.loaderService.hide(); // Hide loader in case of invalid selection
    }
  }

  updateEmployerHealthSubscription3() {

  
    this.loaderService.show();
    this.user.patientId = 0;  // Assign 0 to patientId
    // const isActive = this.activationType === 'Activate';  // True for "Activate", false for "Deactivate"
    this.activationType = "Activate";

    // Check if selectedType is valid and is 'Active'
    if (this.selectedType && this.activationType) {
      // Call the service to update the subscription
    // Navigate to the next component with the subscriptionType as a route parameter
    this.sharedDataService.setData('employerId', this.user.employerId);
    this.sharedDataService.setData('patientId', this.user.patientId);
    this.sharedDataService.setData('subscqriptionTypeId', this.selectedType);
    this.router.navigate(['/employer/setupCheckout', this.selectedType]).then(() => {
      this.loaderService.hide(); // Hide loader after navigation
      document.getElementById("clsModal").click();

    });

    } else {
      // Handle invalid selectedType or inactive type
      console.log("Please select a valid active subscription type.");
      this.loaderService.hide(); // Hide loader in case of invalid selection
    }
  }
  updateEmployerHealthSubscription() {

  
    this.loaderService.show();
    // const isActive = this.activationType === 'Activate';  // True for "Activate", false for "Deactivate"
    this.activationType = "Activate";

    // Check if selectedType is valid and is 'Active'
    if (this.selectedType && this.activationType) {
      // Call the service to update the subscription
    // Navigate to the next component with the subscriptionType as a route parameter
 
      this.employerService
        .updateEmployerHealthSubscription(
          this.user.employerId,
          this.selectedType,
          this.activationType,
        )
        .subscribe(
          (result) => {
            console.log("result update employer subscription", result);
            this.subscriptionType = this.selectedType;
            this.activationType = this.activationType;
            // this.isActive = result.active;  // Set the active status (true or false)

            console.log("result update employer subscriptionType", this.subscriptionType);
            console.log("result update employer activationType", this.activationType);
            // this.getUserDetails();
            // this.utils.showMessageSnackBar(JSON.stringify(result));   
            this.utils.showMessageSnackBar('program subscribed successfully.');
            this.getUserDetails();

            this.loaderService.hide();
            document.getElementById("clsModal").click();
          },
          (error) => {
            console.error(error);
            this.loaderService.hide();
            this.utils.showMessageSnackBar(error.error,true);
            this.utils.showMessageSnackBar('please try again.');


          }
        );
    } else {
      // Handle invalid selectedType or inactive type
      console.log("Please select a valid active subscription type.");
      this.loaderService.hide(); // Hide loader in case of invalid selection
      
    }
  }
  // activateSubscriptionPlan() {
  //   this.loaderService.show();
  //   this.userService
  //     .chargeUserSubscriptionFee(this.selectedType)
  //     .subscribe(
  //       (res) => {
  //         console.log("payment response",res);
  //         if (res.resultStatus.isSuccess) {
  //           this.errorMessage = "";
  //           // this.utils.showMessageSnackBar(JSON.stringify(res.resultStatus.message));   

  //           this.updateEmployerHealthSubscription();
  //           //  this.router.navigate(["/employer/subscription-method"]);
  //           document.getElementById("clsModal").click();

  //         } else {
  //           document.getElementById("clsModal").click();

  //         const errorMessage = res.resultStatus.errorMessages
  //         ? res.resultStatus.errorMessages.join(", ")
  //         : "Payment failed. Please try again or contact support.";
        
  //       this.utils.showMessageSnackBar(errorMessage, true);

  //         }
  //         this.loaderService.hide();
  //       },
  //       (error) => {
  //         console.error(error);
  //         this.loaderService.hide();
  //         this.utils.showMessageSnackBar(error.ErrorMessage,true);

  //       },
  //       () => {
  //         this.loaderService.hide();
  //       }
  //     );
  // }
  activateSubscriptionPlan() {

  
    this.loaderService.show();
    // const isActive = this.activationType === 'Activate';  // True for "Activate", false for "Deactivate"
    this.activationType = "Activate";

    // Check if selectedType is valid and is 'Active'
    if (this.selectedType && this.activationType) {
      // Call the service to update the subscription
    // Navigate to the next component with the subscriptionType as a route parameter
 
      this.employerService
        .updateEmployerHealthSubscription(
          this.user.employerId,
          this.selectedType,
          this.activationType,
        )
        .subscribe(
          (result) => {
            console.log("result update employer subscription", result);
            this.subscriptionType = this.selectedType;
            this.activationType = this.activationType;
            // this.isActive = result.active;  // Set the active status (true or false)

            console.log("result update employer subscriptionType", this.subscriptionType);
            console.log("result update employer activationType", this.activationType);
            // this.getUserDetails();
            // this.utils.showMessageSnackBar(JSON.stringify(result));   
            this.utils.showMessageSnackBar('program subscribed successfully.');
            this.getUserDetails();

            this.loaderService.hide();
            document.getElementById("clsModal").click();
          },
          (error) => {
            console.error(error);
            this.loaderService.hide();
            this.utils.showMessageSnackBar(error.error,true);
            this.utils.showMessageSnackBar('please try again.');


          }
        );
    } else {
      // Handle invalid selectedType or inactive type
      console.log("Please select a valid active subscription type.");
      this.loaderService.hide(); // Hide loader in case of invalid selection
      
    }
  }
cancelSubscription() {
    this.loaderService.show();

    this.activationType = "Deactivate";
    // this.isActive = false;  // Set active to false explicitly for cancelation

    // Call the service to update the subscription
    this.employerService
      .updateEmployerHealthSubscription(
        this.user.employerId,
        this.selectedType,
        this.activationType,

      )
      .subscribe(
        (result) => {
          console.log("result update", result);
          this.subscriptionType = this.selectedType;
          this.activationType = this.activationType;
          // this.isActive = result.active;  // Set the active status (false)

          console.log("subscriptionType", this.subscriptionType);
          console.log("activationType", this.activationType);
          console.log("isActive", this.isActive);

            // Call to fetch updated subscription details
            this.getUserDetails();
          this.loaderService.hide();
          document.getElementById("clsModalCancel").click();

        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        }
      );
  }

 
  openPdfDialog(planId: number) {
    // Find the selected plan by ID
    const selectedPlan = this.subscriptionTypes.find(plan => plan.id === planId);

    // If the plan is found, open the PDF
    if (selectedPlan) {
      window.open(selectedPlan.planDetailsURLEmployer, "_blank");
    } else {
      console.error("Plan not found");
    }
  }
  
  getPatientSubscriptionTypes(cb: () => void) {
    this.loaderService.show();
    this.patientService.getPatientSubscriptionTypes().subscribe(
      (res) => {
        if (res && res.resultStatus && res.resultStatus.isSuccess && res.result && Array.isArray(res.result)) {
          this.subscriptionTypes = res.result; // Assign the correct array
          console.log("Subscription Types:", this.subscriptionTypes);
  
          // Show success message
          // this.utils.showMessageSnackBar(res.resultStatus.message);
  
          if (typeof cb === "function") {
            cb(); // Call callback function if provided
          }
        } else {
          console.warn("Invalid response structure or request was unsuccessful:", res);
          this.subscriptionTypes = []; // Reset to prevent errors
             // Show error message if isSuccess is false
             const errorMessage = res.resultStatus.errorMessages
             ? res.resultStatus.errorMessages.join(", ")
             : "Failed to fetch subscription details.";
           
           this.utils.showMessageSnackBar(errorMessage, true);
        }
  
        this.loaderService.hide();
      },
      (error) => {
        console.error("Error fetching subscription types:", error);
        this.subscriptionTypes = []; // Reset on error
        this.loaderService.hide();
        // Show error message
      this.utils.showMessageSnackBar("An error occurred while fetching subscription types.");
      }
    );
  }


GetPaymentInformation() {
  
  this.loaderService.blockWithLoader(this.userService.GetPaymentInformation("")).subscribe(data => {
    if (!data || !data.profile || !data.profile.paymentProfiles || data.profile.paymentProfiles.length === 0) {
      this.isPaymentInfoMissing = true;
      this.creditCards = data.profile.paymentProfiles;
      this.customerProfileId = data.profile.customerProfileId;
      // Open the modal manually if needed
      // $('#confirmModal').modal('show');
    } else {
      this.isPaymentInfoMissing = false;
      console.log("Payment Information", data);
      // this.creditCards = data.profile.paymentProfiles;
      // this.customerProfileId = data.profile.customerProfileId;
    }
  });
}

GetPaymentInformation2() {
  this.loaderService.blockWithLoader(this.userService.GetPaymentInformation("")).subscribe(data => {
    console.log("Payment Information", data);

    if (!data || !data.profile || !data.profile.paymentProfiles || data.profile.paymentProfiles.length === 0) {
      // this.utils.showMessageSnackBar("Please add Credit Card details in Payment Methods before selecting any plan.");
      this.snackBar.open(
        'Please add Credit Card details in Payment Methods before selecting any plan.',
        '',
        {
          duration: 5000,
          panelClass: ['red-snackbar'],
          horizontalPosition: 'center',
          verticalPosition: 'top' // use 'top' or 'bottom', but 'center' is not allowed here
        }
      );
      
      
      // this.disableSelectButton = true;
      return;
    }

    console.log("Credit Cards", data.profile.paymentProfiles);
    this.creditCards = data.profile.paymentProfiles;
    this.customerProfileId = data.profile.customerProfileId;
    // this.disableSelectButton = false;
  });
}
    ngOnChanges1(changes: SimpleChanges): void {
    if (changes['activeTab'] && changes['activeTab']) {
      this.handleTabActivation2();
    }
  }

  handleTabActivation2(): void {
    console.log(' Subscriptions tab is active');
    // Your additional logic here
    this.getUserDetails();
  }

    addCreditCard(): void {
      document.getElementById("clsModal").click();

      const dialogRef = this.dialog.open(CreditCardComponent, {
        // height: '45%',
        width: '748px',
        disableClose: true,
        data: this.customerProfileId ? this.customerProfileId : null
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res && res.data && res.data.resultStatus) {
          if (res.data.resultStatus.isSuccess) {
            this.utils.showMessageSnackBar('Credit card saved successfully.');
          }
          else {
            this.utils.showMessageSnackBar(res.data.resultStatus.message, true);
          }
        }
       
      });
    }
}
